"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e = require("./index-b21c4d32.js"),
  t = require("react"),
  r = require("./index-d0daf044.js"),
  n = require("./date-8de39666.js"),
  o = require("./uuid-c3e94ca8.js");
require("tslib");
var u;
exports.Theme = void 0, (u = exports.Theme || (exports.Theme = {})).PJ = "pj", u.PF = "pf", u.WM = "wm", u.ID = "id", u.CITRUS = "citrus-cms";
var a = function a() {
    return document.documentElement.getAttribute("theme") || "";
  },
  c = function c() {
    return a().includes("dark");
  },
  d = function d() {
    c() || document.documentElement.setAttribute("theme", "".concat(a(), " dark"));
  },
  s = function s() {
    c() && document.documentElement.setAttribute("theme", a().replace("dark", "").trim());
  },
  i = function i(e) {
    var t = c() ? "".concat(e, " dark") : e;
    return document.documentElement.setAttribute("theme", t);
  };
exports.useDomReady = e.useDomReady, exports.cellphonePattern = r.cellphonePattern, exports.cpfPattern = r.cpfPattern, exports.currencyMask = r.currencyMask, exports.datePattern = r.datePattern, exports.formatToPattern = r.formatToPattern, exports.addLeadingZeros = n.addLeadingZeros, exports.dateToObject = n.dateToObject, exports.uuid = o.uuid, exports.changeTheme = i, exports.darkModeEnabled = c, exports.disableDarkMode = s, exports.enableDarkMode = d, exports.getCurrentTheme = a, exports.initTheme = function (e, t) {
  return void 0 === e && (e = exports.Theme.PF), i(t ? "".concat(e, " dark") : e);
}, exports.toggleDarkMode = function () {
  return c() ? s() : d();
}, exports.useThemeChange = function (e) {
  var r = e.onThemeChange;
  t.useEffect(function () {
    new MutationObserver(function (e) {
      e.forEach(function (e) {
        "attributes" === e.type && "theme" === e.attributeName && r(document.documentElement.getAttribute("theme"));
      });
    }).observe(document.documentElement, {
      attributes: !0
    });
  }, [r]);
};